import { mapGetters } from 'vuex'

export const timeout = {
  name: 'timeout',
  computed: {
    ...mapGetters({ restaurant: 'getRestaurantInfo' })
  },
  data () {
    return {
      isShowTimeOutPop: false,
      timeoutObj: null
    }
  },
  methods: {
    // timeout 팝업에서 타이머 0 도달시 호출
    // 홈화면 이동
    moveToHome () {
      this.$router.push('/')
    },
    // 설정된 시간 지나면 timeout 팝업 노출
    // 호출시 기존 timeout 초기화
    setTimer () {
      clearTimeout(this.timeoutObj)
      this.timeoutObj = setTimeout(() => {
        this.isShowTimeOutPop = true
      }, this.restaurant.timeOutSec * 1000)
      // console.debug('setTimer---', this.timeoutObj)
    },
    // 자체 타이머를 가진 팝업(LINE QR 등) 노출 중 timeout 팝업이 뜨지 않도록 타이머 정지
    stopTimer () {
      clearTimeout(this.timeoutObj)
    },
    // 해당 화면에 동작 있는지 확인
    // 기본은 click 감시
    // 특정 페이지는 touchstart touchmove 추가 - 타블릿에서 스크롤 동작 감지용
    interactCheck () {
      // console.debug('interactCheck')
      this.setTimer()
    },
    // timeout 팝업 close시 호출
    // timer 재동작
    closeTimeoutPopup () {
      // console.debug('closeTimeoutPopup timeout')
      this.isShowTimeOutPop = false
      this.setTimer()
    }
  },
  // 홈화면이 아닐경우 timer 시작
  mounted () {
    if (this.$route.name !== 'home') {
      this.setTimer()
    }
    // console.debug('timeout mounted---', this.timeoutObj, this.$route.name)
  },
  // 페이지 이탈시 timeout 초기화
  destroyed () {
    clearTimeout(this.timeoutObj)
    // console.debug('timeout destroyed---', this.timeoutObj)
  }
}
